/* NoveaHome — configurateur de pergola 3D (Three.js) */
(function () {
  'use strict';
  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js';
  var threeP = null;
  /* Chargé via un <script type="module"> injecté : les assets Shopify réécrivent import() */
  function loadThree() {
    if (threeP) return threeP;
    threeP = new Promise(function (res, rej) {
      if (window.__pcThree) return res(window.__pcThree);
      var done = function () { window.removeEventListener('pc:three', done); window.__pcThree ? res(window.__pcThree) : rej(new Error('three')); };
      window.addEventListener('pc:three', done);
      var s = document.createElement('script'); s.type = 'module';
      s.textContent = "import * as T from '" + THREE_URL + "'; window.__pcThree = T; window.dispatchEvent(new Event('pc:three'));";
      s.onerror = function () { rej(new Error('three')); };
      document.head.appendChild(s);
      setTimeout(function () { if (!window.__pcThree) rej(new Error('three timeout')); }, 20000);
    });
    return threeP;
  }

  var COLORS = { anthracite: '#3a3d41', gris: '#8b8f93', gray: '#8b8f93', grey: '#8b8f93', beige: '#d8c9a8', vert: '#4b6a44', green: '#4b6a44', noir: '#1b1b1b', black: '#1b1b1b', blanc: '#eeeeee', white: '#eeeeee', taupe: '#8b7d6b', marron: '#6b4a33', brown: '#6b4a33', creme: '#e8dfca', cream: '#e8dfca' };
  var NAMES = { gray: 'Gris', grey: 'Gris', green: 'Vert', black: 'Noir', white: 'Blanc', brown: 'Marron', cream: 'Crème' };
  function hexFor(n, fb) { if (!n) return fb; var k = n.toLowerCase(); for (var c in COLORS) { if (k.indexOf(c) > -1) return COLORS[c]; } return fb; }
  function niceName(n) { if (!n) return ''; var k = n.toLowerCase(); return NAMES[k] || n; }
  function mm(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' mm'; }

  /* ================= 3D viewer ================= */
  function Viewer(host, T) {
    var self = this;
    this.T = T; this.host = host;
    var r = this.renderer = new T.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' });
    r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    r.shadowMap.enabled = true; r.shadowMap.type = T.PCFSoftShadowMap;
    r.outputColorSpace = T.SRGBColorSpace; r.toneMapping = T.ACESFilmicToneMapping; r.toneMappingExposure = 1.05;
    host.appendChild(r.domElement);

    var s = this.scene = new T.Scene();
    this.camera = new T.PerspectiveCamera(38, 1, 0.1, 400);
    this.px = -1.5; this.z0 = 0.15;
    this.target = new T.Vector3(this.px, 1.2, 1.6);
    this.orbit = { th: 0.62, ph: 1.12, r: 15, tth: 0.62, tph: 1.12, tr: 15 };

    this.hemi = new T.HemisphereLight(0xffffff, 0x8a9a6a, 1.1); s.add(this.hemi);
    var sun = this.sun = new T.DirectionalLight(0xfff4e2, 2.6);
    sun.position.set(-9, 16, 11); sun.castShadow = true;
    sun.shadow.mapSize.set(2048, 2048); sun.shadow.bias = -0.0004; sun.shadow.normalBias = 0.02;
    var sc = sun.shadow.camera; sc.left = -16; sc.right = 16; sc.top = 16; sc.bottom = -16; sc.near = 1; sc.far = 60;
    sun.target.position.set(this.px, 0, 1); s.add(sun); s.add(sun.target);

    this.windows = []; this.nightLights = []; this.glows = [];
    this.buildEnv(); this.buildHouse(); this.buildWall(); this.buildGarden(); this.buildFurniture();
    this.pergola = new T.Group(); s.add(this.pergola);
    this.setNight(false); this.setOnly(false);
    this.bindControls();
    this.labels = {};
    ['w', 'd', 'h'].forEach(function (k) { self.labels[k] = host.parentNode.querySelector('[data-lab="' + k + '"]'); });

    this.visible = true; this.dirty = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; }).observe(host);
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.resize(); }).observe(host);
    window.addEventListener('resize', function () { self.resize(); });
    this.resize();
    var loop = function () { requestAnimationFrame(loop); if (self.visible && !document.hidden) self.frame(); };
    loop();
  }
  var V = Viewer.prototype;

  V.mat = function (c, o) { var m = new this.T.MeshStandardMaterial({ color: c, roughness: 0.85, metalness: 0 }); if (o) for (var k in o) m[k] = o[k]; return m; };
  V.box = function (w, h, d, m, x, y, z, parent, noShadow) {
    var b = new this.T.Mesh(new this.T.BoxGeometry(w, h, d), m); b.position.set(x, y, z);
    if (!noShadow) { b.castShadow = true; b.receiveShadow = true; }
    (parent || this.scene).add(b); return b;
  };
  V.canvasTex = function (size, draw, rx, ry) {
    var T = this.T, c = document.createElement('canvas'); c.width = c.height = size;
    draw(c.getContext('2d'), size);
    var t = new T.CanvasTexture(c); t.colorSpace = T.SRGBColorSpace; t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(rx || 1, ry || 1);
    t.anisotropy = 4; return t;
  };

  V.buildEnv = function () {
    var T = this.T;
    var grass = this.canvasTex(256, function (g, n) {
      g.fillStyle = '#7da352'; g.fillRect(0, 0, n, n);
      for (var i = 0; i < 2600; i++) { g.fillStyle = Math.random() > 0.5 ? 'rgba(60,100,30,.25)' : 'rgba(170,200,110,.22)'; g.fillRect(Math.random() * n, Math.random() * n, 2, 2); }
    }, 40, 40);
    this.grassMat = this.mat(0xffffff, { map: grass, roughness: 1 });
    this.plainMat = this.mat(0xcfd2cf, { roughness: 1 });
    var ground = this.ground = new T.Mesh(new T.PlaneGeometry(160, 160), this.grassMat);
    ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; this.scene.add(ground);
    var tile = this.canvasTex(256, function (g, n) {
      g.fillStyle = '#dcdad4'; g.fillRect(0, 0, n, n);
      for (var i = 0; i < 900; i++) { g.fillStyle = 'rgba(0,0,0,.035)'; g.fillRect(Math.random() * n, Math.random() * n, 3, 3); }
      g.strokeStyle = '#c3c0b8'; g.lineWidth = 3;
      for (var k = 0; k <= n; k += n / 2) { g.beginPath(); g.moveTo(k, 0); g.lineTo(k, n); g.stroke(); g.beginPath(); g.moveTo(0, k); g.lineTo(n, k); g.stroke(); }
    }, 1, 1);
    this.tileTex = tile;
    this.slab = new T.Mesh(new T.BoxGeometry(1, 0.08, 1), this.mat(0xffffff, { map: tile, roughness: 0.95 }));
    this.slab.receiveShadow = true; this.scene.add(this.slab);
  };

  V.buildHouse = function () {
    var T = this.T, g = this.house = new T.Group(), px = this.px; this.scene.add(g);
    var white = this.mat(0xf2f1ed, { roughness: 0.92 }), dark = this.mat(0x2b2d30, { roughness: 0.6 }), grey = this.mat(0x74787c);
    this.box(13, 3.3, 9, white, px - 0.5, 1.65, -4.5, g);
    this.box(13.3, 0.28, 9.3, this.mat(0xe4e3df), px - 0.5, 3.44, -4.5, g);
    this.box(12.6, 0.04, 8.6, this.mat(0xb9b6ae), px - 0.5, 3.56, -4.5, g, true);
    this.box(13.04, 0.28, 9.04, grey, px - 0.5, 0.14, -4.5, g);
    var wood = this.canvasTex(256, function (c, n) {
      c.fillStyle = '#9a6640'; c.fillRect(0, 0, n, n);
      var pw = n / 8;
      for (var i = 0; i < 8; i++) { var l = 0.85 + Math.random() * 0.3; c.fillStyle = 'rgba(' + Math.round(160 * l) + ',' + Math.round(108 * l) + ',' + Math.round(68 * l) + ',1)'; c.fillRect(i * pw + 2, 0, pw - 4, n); c.fillStyle = 'rgba(40,20,5,.55)'; c.fillRect(i * pw, 0, 2, n); }
      for (var j = 0; j < 160; j++) { c.fillStyle = 'rgba(60,30,10,.12)'; c.fillRect(Math.random() * n, Math.random() * n, 1, 20 + Math.random() * 40); }
    }, 3, 1);
    var ax = px + 8.1;
    this.box(4.6, 3.9, 6.4, this.mat(0xffffff, { map: wood, roughness: 0.8 }), ax, 1.95, -2.8, g);
    this.box(4.8, 0.2, 6.6, dark, ax, 3.98, -2.8, g);
    var glass = this.mat(0x26323a, { roughness: 0.12, metalness: 0.4, emissive: new T.Color(0xffc879), emissiveIntensity: 0 });
    var self = this;
    var win = function (w, h, x, y, z) {
      self.box(w + 0.12, h + 0.12, 0.06, dark, x, y, z, g);
      var m = self.box(w, h, 0.05, glass, x, y, z + 0.02, g, true); self.windows.push(m); return m;
    };
    win(3.2, 2.3, px, 1.3, 0.01);
    win(1.5, 1.7, px - 5.2, 1.7, 0.01);
    win(1.6, 1.9, ax - 0.5, 1.7, 0.41);
    win(0.5, 2.3, ax + 1.5, 1.3, 0.41);
    this.box(0.12, 2.4, 0.06, dark, px - 0.1, 1.3, 0.05, g);
    var sconce = this.mat(0x222222, { emissive: new T.Color(0xffd79a), emissiveIntensity: 0 });
    [px - 2.4, px + 2.4].forEach(function (x) {
      var b = self.box(0.12, 0.26, 0.12, sconce, x, 2.3, 0.07, g); self.glows.push(b);
      var l = new T.PointLight(0xffc77a, 0, 6, 2); l.position.set(x, 2.1, 0.4); g.add(l); self.nightLights.push([l, 4]);
    });
  };

  V.buildWall = function () {
    var T = this.T, g = this.wall = new T.Group(); this.scene.add(g);
    var m = this.mat(0x8c9094, { roughness: 0.95 });
    this.box(12, 3.2, 0.3, m, this.px, 1.6, -0.15, g);
    var glass = this.mat(0x26323a, { roughness: 0.12, metalness: 0.4, emissive: new T.Color(0xffc879), emissiveIntensity: 0 });
    this.windows.push(this.box(2.6, 2.2, 0.05, glass, this.px, 1.2, 0.02, g, true));
    this.windows.push(this.box(1.2, 1.4, 0.05, glass, this.px + 3.8, 1.7, 0.02, g, true));
    this.windows.push(this.box(1.2, 1.4, 0.05, glass, this.px - 3.8, 1.7, 0.02, g, true));
  };

  V.tree = function (x, z, s, col, g) {
    var T = this.T;
    var trunk = new T.Mesh(new T.CylinderGeometry(0.09 * s, 0.14 * s, 1.8 * s, 6), this.mat(0x6b4f36));
    trunk.position.set(x, 0.9 * s, z); trunk.castShadow = true; g.add(trunk);
    var m = this.mat(col, { flatShading: true, roughness: 0.95 });
    var n = 3 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) {
      var c = new T.Mesh(new T.IcosahedronGeometry((0.75 + Math.random() * 0.5) * s, 1), m);
      c.position.set(x + (Math.random() - 0.5) * 1.1 * s, (2.1 + Math.random() * 1.0) * s, z + (Math.random() - 0.5) * 1.1 * s);
      c.castShadow = true; g.add(c);
    }
  };

  V.buildGarden = function () {
    var T = this.T, g = this.garden = new T.Group(), px = this.px, self = this; this.scene.add(g);
    var greens = [0x5f8a3f, 0x6f9a48, 0x4f7a37, 0x7aa055];
    var spots = [[-11, 3, 1.3], [-12.5, -6, 1.5], [12.5, -4, 1.4], [13, 6, 1.2], [-8, 11, 1.1], [7, 12, 1.0], [-18, -14, 1.8], [-6, -16, 2], [6, -17, 1.9], [17, -12, 1.7], [22, 4, 1.6], [-22, 2, 1.7]];
    spots.forEach(function (p, i) { self.tree(p[0], p[1], p[2], greens[i % greens.length], g); });
    this.tree(px + 5.4, 2.6, 0.9, 0x7c2b37, g);
    var shrub = this.mat(0x4e7a35, { flatShading: true, roughness: 1 });
    var flowers = [this.mat(0x8e6cc7), this.mat(0xe8a0b8), this.mat(0xf2f2f2)];
    var row = function (x1, x2, z) {
      for (var x = x1; x <= x2; x += 0.62) {
        var b = new T.Mesh(new T.IcosahedronGeometry(0.32 + Math.random() * 0.14, 1), shrub);
        b.position.set(x, 0.3, z + (Math.random() - 0.5) * 0.2); b.castShadow = true; g.add(b);
        if (Math.random() > 0.45) { var f = new T.Mesh(new T.SphereGeometry(0.07, 6, 6), flowers[Math.floor(Math.random() * 3)]); f.position.set(x + 0.1, 0.62, z + 0.12); g.add(f); }
      }
    };
    row(px - 7.6, px - 3.4, 0.55); row(px + 2.9, px + 5.4, 0.55);
    var bed = this.mat(0x4a3a2c, { roughness: 1 });
    this.box(4.6, 0.06, 0.9, bed, px - 5.5, 0.03, 0.55, g, true); this.box(2.8, 0.06, 0.9, bed, px + 4.15, 0.03, 0.55, g, true);
    this.stones = new T.Group(); g.add(this.stones);
    this.bollards = new T.Group(); g.add(this.bollards);
    this.stoneMat = this.mat(0xb9b9b4, { roughness: 1 });
    this.bolMat = this.mat(0x1d1d1d, { roughness: 0.5 });
    this.bolHead = this.mat(0x2a2a2a, { emissive: new T.Color(0xffd28c), emissiveIntensity: 0 });
    this.glows.push({ material: this.bolHead });
    var pot = this.mat(0xb76a45), plant = this.mat(0x5d8c3c, { flatShading: true });
    this.pots = [];
    for (var i = 0; i < 2; i++) {
      var pg = new T.Group();
      var c = new T.Mesh(new T.CylinderGeometry(0.28, 0.2, 0.5, 14), pot); c.position.y = 0.25; c.castShadow = true; pg.add(c);
      var p = new T.Mesh(new T.IcosahedronGeometry(0.42, 1), plant); p.position.y = 0.78; p.castShadow = true; pg.add(p);
      g.add(pg); this.pots.push(pg);
    }
  };

  V.layoutGarden = function (w, d) {
    var T = this.T, px = this.px, front = this.z0 + d + 1.2, self = this;
    while (this.stones.children.length) this.stones.remove(this.stones.children[0]);
    while (this.bollards.children.length) this.bollards.remove(this.bollards.children[0]);
    this.nightLights = this.nightLights.filter(function (n) { return !n[2]; });
    for (var i = 0; i < 7; i++) {
      var st = new T.Mesh(new T.CylinderGeometry(0.34, 0.36, 0.05, 16), this.stoneMat);
      st.position.set(px + Math.sin(i * 0.5) * 0.5, 0.025, front + 0.5 + i * 0.85); st.receiveShadow = true; this.stones.add(st);
    }
    [[-1.0, 0.9], [1.0, 2.6], [-1.0, 4.3], [1.0, 5.6]].forEach(function (b) {
      var x = px + b[0], z = front + b[1];
      var post = new T.Mesh(new T.CylinderGeometry(0.06, 0.06, 0.55, 10), self.bolMat); post.position.set(x, 0.275, z); post.castShadow = true; self.bollards.add(post);
      var head = new T.Mesh(new T.CylinderGeometry(0.075, 0.075, 0.08, 10), self.bolHead); head.position.set(x, 0.56, z); self.bollards.add(head);
      var l = new T.PointLight(0xffc477, 0, 3.5, 2); l.position.set(x, 0.45, z); self.bollards.add(l); self.nightLights.push([l, 2.2, true]);
    });
    this.pots[0].position.set(px - w / 2 - 0.55, 0.04, this.z0 + d + 0.35);
    this.pots[1].position.set(px + w / 2 + 0.55, 0.04, this.z0 + 0.6);
  };

  V.buildFurniture = function () {
    var T = this.T, g = this.furn = new T.Group(); this.scene.add(g);
    var fabric = this.mat(0xebe7df, { roughness: 1 }), frame = this.mat(0x3b3b3b, { roughness: 0.5 }), wood = this.mat(0x9a6a40, { roughness: 0.7 });
    this.rug = this.box(1, 0.012, 1, this.mat(0xe9e3d5, { roughness: 1 }), 0, 0.09, 0, g, true); this.rug.receiveShadow = true;
    var sofa = new T.Group(); g.add(sofa); this.sofa = sofa;
    this.box(2.1, 0.12, 0.85, frame, 0, 0.16, 0, sofa);
    this.box(2.0, 0.22, 0.78, fabric, 0, 0.33, 0.02, sofa);
    this.box(2.0, 0.45, 0.18, fabric, 0, 0.55, -0.32, sofa);
    this.box(0.14, 0.32, 0.8, frame, -1.03, 0.36, 0, sofa); this.box(0.14, 0.32, 0.8, frame, 1.03, 0.36, 0, sofa);
    this.box(0.42, 0.36, 0.12, this.mat(0x9fb08f), -0.6, 0.6, -0.2, sofa); this.box(0.4, 0.34, 0.12, this.mat(0xd09a6e), 0.55, 0.6, -0.2, sofa);
    var table = new T.Group(); g.add(table); this.table = table;
    this.box(1.05, 0.05, 0.6, wood, 0, 0.42, 0, table);
    [[-0.45, -0.24], [0.45, -0.24], [-0.45, 0.24], [0.45, 0.24]].forEach(function (p) { table.add(new T.Mesh(new T.BoxGeometry(0.04, 0.4, 0.04), frame)); table.children[table.children.length - 1].position.set(p[0], 0.2, p[1]); });
    var lantern = new T.Mesh(new T.CylinderGeometry(0.07, 0.07, 0.2, 10), this.mat(0x222222, { emissive: new T.Color(0xffc477), emissiveIntensity: 0 }));
    lantern.position.set(0.25, 0.55, 0); table.add(lantern); this.glows.push(lantern);
    var ll = new T.PointLight(0xffb866, 0, 5, 2); ll.position.set(0.25, 0.7, 0); table.add(ll); this.nightLights.push([ll, 3]);
  };

  V.setModel = function (cfg, color) {
    var T = this.T, g = this.pergola, px = this.px, z0 = this.z0, self = this;
    while (g.children.length) { var c = g.children[0]; g.remove(c); c.traverse && c.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); }
    this.nightLights = this.nightLights.filter(function (n) { return !n[3]; });
    var w = cfg.w / 1000, d = cfg.d / 1000, h = (cfg.h || 2500) / 1000;
    this.dims = { w: w, d: d, h: h, mmW: cfg.w, mmD: cfg.d, mmH: cfg.h };
    var fabricTarget = cfg.target === 'fabric';
    var frameHex = fabricTarget ? '#3a3d41' : hexFor(color, '#3a3d41');
    var fabricHex = fabricTarget ? hexFor(color, '#d6d3cc') : '#d6d3cc';
    var fm = this.mat(new T.Color(frameHex), { roughness: 0.45, metalness: 0.35 });
    var louvre = cfg.roof !== 'canopy';
    var s = louvre ? 0.12 : 0.085, bh = louvre ? 0.22 : 0.1;
    var zc = z0 + d / 2, xL = px - w / 2 + s / 2, xR = px + w / 2 - s / 2, zB = z0 + s / 2, zF = z0 + d - s / 2;
    [[xL, zB], [xR, zB], [xL, zF], [xR, zF]].forEach(function (p) {
      self.box(s, h, s, fm, p[0], h / 2, p[1], g);
      self.box(s + 0.08, 0.02, s + 0.08, fm, p[0], 0.1, p[1], g);
    });
    this.box(w, bh, s, fm, px, h - bh / 2, zB, g); this.box(w, bh, s, fm, px, h - bh / 2, zF, g);
    this.box(s, bh, d, fm, xL, h - bh / 2, zc, g); this.box(s, bh, d, fm, xR, h - bh / 2, zc, g);
    this.slats = []; this.cloth = null;
    if (louvre) {
      var inner = d - 2 * s, n = Math.max(8, Math.round(inner / 0.165)), pitch = inner / n;
      var sm = this.mat(new T.Color(frameHex), { roughness: 0.5, metalness: 0.3 });
      var geo = new T.BoxGeometry(w - 2 * s - 0.02, 0.024, pitch * 0.98);
      for (var i = 0; i < n; i++) {
        var sl = new T.Mesh(geo, sm); sl.castShadow = true; sl.receiveShadow = true;
        sl.position.set(px, h - bh * 0.45, z0 + s + pitch * (i + 0.5)); g.add(sl); this.slats.push(sl);
      }
    } else {
      this.box(w - 2 * s, 0.05, 0.05, fm, px, h - 0.03, z0 + d * 0.5, g);
      this.cloth = new T.Group(); g.add(this.cloth);
      this.clothMat = this.mat(new T.Color(fabricHex), { roughness: 1, side: T.DoubleSide });
      this.clothSpan = { x: px, w: w - 2 * s - 0.02, y: h - 0.02, z1: z0 + s, len: d - 2 * s };
    }
    if (cfg.led) {
      var led = this.mat(0x111111, { emissive: new T.Color(0xffd9a0), emissiveIntensity: 0 });
      this.box(w - 2 * s, 0.015, 0.03, led, px, h - bh - 0.01, zB + s / 2 + 0.02, g, true);
      this.box(w - 2 * s, 0.015, 0.03, led, px, h - bh - 0.01, zF - s / 2 - 0.02, g, true);
      this.glows.push(g.children[g.children.length - 1], g.children[g.children.length - 2]);
      var pl = new T.PointLight(0xffd4a0, 0, 7, 2); pl.position.set(px, h - 0.4, zc); g.add(pl); this.nightLights.push([pl, 6, false, true]);
    }
    this.slab.scale.set(w + 2.6, 1, d + 1.4); this.slab.position.set(px, 0.04, z0 + (d + 1.4) / 2 - 0.02);
    this.tileTex.repeat.set((w + 2.6) / 1.2, (d + 1.4) / 1.2);
    this.rug.scale.set(Math.min(2.8, w * 0.72), 1, Math.min(2.2, d * 0.6)); this.rug.position.set(px, 0.09, zc + 0.15);
    this.sofa.position.set(px, 0.08, zc - Math.min(0.6, d * 0.18)); this.table.position.set(px, 0.08, zc + 0.55);
    this.layoutGarden(w, d);
    this.target.set(px, Math.min(1.3, h * 0.5), zc);
    this.setRoof(this.roofVal == null ? 30 : this.roofVal);
    this.setNight(this.night);
    this.dirty = true;
  };

  V.setRoof = function (v) {
    this.roofVal = v;
    if (this.slats && this.slats.length) { var a = v * Math.PI / 180; this.slats.forEach(function (s) { s.rotation.x = a; }); }
    if (this.cloth) {
      var T = this.T, c = this.cloth, sp = this.clothSpan;
      while (c.children.length) { var o = c.children[0]; c.remove(o); o.geometry.dispose(); }
      var open = v / 90, cover = sp.len * (1 - open * 0.82), folds = 7, seg = cover / folds;
      var sag = 0.03 + open * 0.07, ang = Math.atan2(sag, seg / 2);
      var len = Math.sqrt(Math.pow(seg / 2, 2) + sag * sag);
      for (var i = 0; i < folds; i++) {
        for (var k = 0; k < 2; k++) {
          var m = new T.Mesh(new T.PlaneGeometry(sp.w, len), this.clothMat);
          m.rotation.x = -Math.PI / 2 + (k ? -ang : ang);
          m.position.set(sp.x, sp.y - sag / 2, sp.z1 + i * seg + (k ? seg * 0.75 : seg * 0.25));
          m.castShadow = true; m.receiveShadow = true; c.add(m);
        }
      }
    }
    this.dirty = true;
  };

  V.setNight = function (on) {
    var T = this.T; this.night = !!on;
    var sky = on ? new T.Color(0x0d1626) : new T.Color(0xe4eaea);
    this.scene.background = sky;
    this.scene.fog = new T.Fog(sky, on ? 18 : 26, on ? 70 : 95);
    this.hemi.intensity = on ? 0.12 : 1.1; this.hemi.color.set(on ? 0x7d8fb8 : 0xffffff);
    this.sun.intensity = on ? 0.18 : 2.6; this.sun.color.set(on ? 0x9fb4e0 : 0xfff4e2);
    this.renderer.toneMappingExposure = on ? 1.25 : 1.05;
    this.windows.forEach(function (m) { m.material.emissiveIntensity = on ? 0.9 : 0; });
    this.glows.forEach(function (m) { if (m && m.material) m.material.emissiveIntensity = on ? 2.2 : 0; });
    this.nightLights.forEach(function (n) { n[0].intensity = on ? n[1] : 0; });
    this.dirty = true;
  };

  V.setOnly = function (on) {
    this.only = !!on;
    this.house.visible = !on; this.garden.visible = !on; this.wall.visible = on;
    this.ground.material = on ? this.plainMat : this.grassMat;
    this.dirty = true;
  };

  V.bindControls = function () {
    var self = this, el = this.renderer.domElement, o = this.orbit, ptrs = {}, last = null, pinch = null;
    el.addEventListener('pointerdown', function (e) { el.setPointerCapture(e.pointerId); ptrs[e.pointerId] = [e.clientX, e.clientY]; last = [e.clientX, e.clientY]; });
    el.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = [e.clientX, e.clientY];
      var ids = Object.keys(ptrs);
      if (ids.length === 2) {
        var a = ptrs[ids[0]], b = ptrs[ids[1]], dd = Math.hypot(a[0] - b[0], a[1] - b[1]);
        if (pinch) o.tr = Math.min(30, Math.max(5, o.tr * pinch / dd));
        pinch = dd; return;
      }
      if (!last) return;
      o.tth -= (e.clientX - last[0]) * 0.006; o.tph = Math.min(1.45, Math.max(0.25, o.tph - (e.clientY - last[1]) * 0.005));
      last = [e.clientX, e.clientY];
    });
    var up = function (e) { delete ptrs[e.pointerId]; pinch = null; last = null; var ids = Object.keys(ptrs); if (ids.length === 1) last = ptrs[ids[0]]; };
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
    el.addEventListener('wheel', function (e) { e.preventDefault(); o.tr = Math.min(30, Math.max(5, o.tr * (1 + Math.sign(e.deltaY) * 0.08))); }, { passive: false });
  };

  V.resize = function () {
    var w = this.host.clientWidth, h = this.host.clientHeight; if (!w || !h) return;
    this.renderer.setSize(w, h, false); this.camera.aspect = w / h;
    this.camera.fov = w / h < 1 ? 50 : 38; this.camera.updateProjectionMatrix(); this.dirty = true;
  };

  V.frame = function () {
    var o = this.orbit, k = 0.14, moving = Math.abs(o.tth - o.th) + Math.abs(o.tph - o.ph) + Math.abs(o.tr - o.r) > 1e-4;
    if (!moving && !this.dirty) return;
    o.th += (o.tth - o.th) * k; o.ph += (o.tph - o.ph) * k; o.r += (o.tr - o.r) * k;
    var t = this.target, c = this.camera;
    c.position.set(t.x + o.r * Math.sin(o.ph) * Math.sin(o.th), t.y + o.r * Math.cos(o.ph), t.z + o.r * Math.sin(o.ph) * Math.cos(o.th));
    c.lookAt(t);
    this.renderer.render(this.scene, c);
    this.updateLabels(); this.dirty = false;
  };

  V.updateLabels = function () {
    if (!this.dims) return;
    var T = this.T, d = this.dims, px = this.px, z0 = this.z0, self = this;
    var w = this.host.clientWidth, h = this.host.clientHeight;
    var pts = {
      w: [new T.Vector3(px, 0.12, z0 + d.d + 0.25), d.mmW],
      d: [new T.Vector3(px + d.w / 2 + 0.3, 0.12, z0 + d.d / 2), d.mmD],
      h: [new T.Vector3(px + d.w / 2, d.h * 0.55, z0 + d.d), d.mmH]
    };
    Object.keys(pts).forEach(function (k) {
      var el = self.labels[k]; if (!el) return;
      var p = pts[k][0].clone().project(self.camera), val = pts[k][1];
      if (!val || p.z > 1) { el.hidden = true; return; }
      el.hidden = false; el.textContent = mm(val);
      el.style.transform = 'translate(' + ((p.x + 1) / 2 * w - el.offsetWidth / 2) + 'px,' + ((1 - p.y) / 2 * h - el.offsetHeight / 2) + 'px)';
    });
  };

  /* ================= Configurator UI ================= */
  function Cfg(root) {
    var self = this;
    this.root = root;
    this.models = JSON.parse(root.querySelector('[data-pc-models]').textContent || '[]');
    if (!this.models.length) return;
    this.cur = root.dataset.currency || 'EUR';
    this.q = function (s) { return root.querySelector(s); };
    this.qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var params = new URLSearchParams(location.search);
    var want = params.get('model') || root.dataset.current;
    this.mi = Math.max(0, this.models.findIndex(function (m) { return m.handle === want; }));
    var wantV = +params.get('variant') || 0;
    this.vi = 0; this.wantV = wantV;
    this.step = 0;

    this.qa('[data-model]').forEach(function (b) {
      b.addEventListener('click', function () { var i = self.models.findIndex(function (m) { return m.handle === b.dataset.model; }); if (i > -1) { self.mi = i; self.vi = -1; self.render(true); } });
    });
    this.q('[data-colors]').addEventListener('click', function (e) { var b = e.target.closest('button[data-v]'); if (!b || b.disabled) return; self.vi = +b.dataset.v; self.renderVariant(); });
    var sun = this.q('[data-i-sun]'); if (sun) sun.style.display = 'none';
    var sl = this.q('[data-sl]');
    sl.addEventListener('input', function () { self.renderSlider(); if (self.viewer) self.viewer.setRoof(+sl.value); });
    this.q('[data-night]').addEventListener('click', function () {
      var on = this.getAttribute('aria-pressed') !== 'true'; this.setAttribute('aria-pressed', on);
      this.querySelector('span').textContent = on ? 'Vue de jour' : 'Vue de nuit';
      this.querySelector('[data-i-moon]').style.display = on ? 'none' : ''; this.querySelector('[data-i-sun]').style.display = on ? '' : 'none';
      root.classList.toggle('is-night', on); if (self.viewer) self.viewer.setNight(on);
    });
    this.q('[data-scene]').addEventListener('click', function () {
      var on = this.getAttribute('aria-pressed') !== 'true'; this.setAttribute('aria-pressed', on);
      this.querySelector('span').textContent = on ? 'Maison et jardin' : 'Pergola seule';
      if (self.viewer) self.viewer.setOnly(on);
    });
    this.q('[data-share]').addEventListener('click', function () { self.share(this); });
    this.q('[data-print]').addEventListener('click', function () { window.print(); });
    this.q('[data-next]').addEventListener('click', function () { self.next(this); });
    this.scroller = this.q('[data-scroll]');
    this.scroller.addEventListener('scroll', function () { self.trackStep(); }, { passive: true });
    document.addEventListener('scroll', function (e) { if (e.target !== self.scroller) self.trackStep(); }, { passive: true, capture: true });

    this.render();
    this.boot3d();
  }
  var C = Cfg.prototype;

  C.money = function (c) { try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: this.cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' €'; } };
  C.model = function () { return this.models[this.mi]; };
  C.variant = function () { return this.model().variants[this.vi]; };

  C.render = function (byUser) {
    var m = this.model(), self = this;
    this.qa('[data-model]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.model === m.handle); b.setAttribute('aria-pressed', b.dataset.model === m.handle); });
    this.q('[data-title]').textContent = m.title;
    this.q('[data-pdp]').href = m.url;
    var dims = '<b>' + (m.w / 1000).toLocaleString('fr-FR') + ' × ' + (m.d / 1000).toLocaleString('fr-FR') + ' m</b><span>' + mm(m.w) + ' × ' + mm(m.d) + (m.h ? ' · hauteur ' + mm(m.h) : '') + '</span>' + (m.dim_note ? '<span>' + m.dim_note + '</span>' : '');
    this.q('[data-dims]').innerHTML = dims;
    if (this.vi < 0 || this.vi >= m.variants.length) {
      var wi = m.variants.findIndex(function (v) { return v.id === self.wantV; });
      this.vi = wi > -1 ? wi : Math.max(0, m.variants.findIndex(function (v) { return v.ok; }));
    }
    if (this.wantV) { var wj = m.variants.findIndex(function (v) { return v.id === self.wantV; }); if (wj > -1) this.vi = wj; this.wantV = 0; }
    var sw = this.q('[data-colors]');
    sw.innerHTML = m.variants.map(function (v, i) {
      var name = niceName(v.color || v.title);
      return '<button type="button" data-v="' + i + '" title="' + name.replace(/"/g, '') + '" aria-label="' + name.replace(/"/g, '') + '" style="background:' + hexFor(v.color || v.title, '#9a9a9a') + '"' + (v.ok ? '' : ' disabled') + '></button>';
    }).join('');
    var sl = this.q('[data-sl]');
    if (m.roof === 'canopy') { sl.max = 90; this.q('[data-sl-label]').textContent = 'Ouverture de la toile'; }
    else { sl.max = 90; this.q('[data-sl-label]').textContent = 'Réglage des lames'; }
    this.renderSlider();
    this.renderVariant(true);
    if (byUser && this.root.dataset.sync && history.replaceState) { var u = new URL(location.href); u.searchParams.set('model', m.handle); u.searchParams.delete('variant'); history.replaceState({}, '', u); }
    var fb = this.q('[data-fb]'); if (m.img) fb.src = m.img;
  };

  C.renderSlider = function () {
    var v = +this.q('[data-sl]').value, m = this.model();
    this.q('[data-sl-val]').textContent = m.roof === 'canopy' ? Math.round(v / 90 * 100) + ' %' : v + '°';
  };

  C.renderVariant = function (skip3d) {
    var m = this.model(), v = this.variant();
    this.qa('[data-colors] button').forEach(function (b) { b.classList.toggle('is-on', +b.dataset.v === this.vi); }, this);
    this.q('[data-color-name]').textContent = niceName(v.color || v.title);
    this.q('[data-price]').textContent = this.money(v.price);
    var was = this.q('[data-was]'); was.hidden = !(v.cap > v.price); was.textContent = v.cap > v.price ? this.money(v.cap) : '';
    this.setNextLabel();
    if (this.viewer) this.viewer.setModel(m, v.color || v.title);
  };

  C.steps = function () { return this.qa('.pc-cfg__step'); };
  C.panelScrolls = function () { var s = this.scroller; return s.scrollHeight > s.clientHeight + 2 && getComputedStyle(s).overflowY !== 'visible'; };
  C.trackStep = function () {
    var st = this.steps(), s = this.scroller, i = 0;
    if (this.panelScrolls()) {
      var top = s.getBoundingClientRect().top;
      st.forEach(function (el, k) { if (el.getBoundingClientRect().top - top < 80) i = k; });
      if (s.scrollTop + s.clientHeight >= s.scrollHeight - 4) i = st.length - 1;
    } else {
      st.forEach(function (el, k) { if (el.getBoundingClientRect().top < window.innerHeight * 0.45) i = k; });
    }
    if (i !== this.step) { this.step = i; this.setNextLabel(); }
  };
  C.setNextLabel = function () {
    var b = this.q('[data-next]'), last = this.step >= this.steps().length - 1, v = this.variant();
    b.dataset.mode = last ? 'atc' : 'next';
    b.textContent = last ? (v.ok ? 'Ajouter au panier' : 'Épuisé') : 'Suivant →';
    b.disabled = last && !v.ok;
  };
  C.next = function (btn) {
    if (btn.dataset.mode === 'atc') return this.add(btn);
    var st = this.steps(), i = Math.min(st.length - 1, this.step + 1), el = st[i], s = this.scroller;
    if (this.panelScrolls()) s.scrollTo({ top: el.offsetTop - s.firstElementChild.offsetTop - 8, behavior: 'smooth' });
    else { el.style.scrollMarginTop = '96px'; el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    this.step = i; this.setNextLabel();
  };
  C.add = function (btn) {
    var self = this, v = this.variant(), msg = this.q('[data-msg-t]'), base = msg.textContent;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { if (window.NVCart && window.NVCart.open) window.NVCart.open(); else location.href = '/cart'; })
      .catch(function (err) { msg.parentNode.classList.add('pc-cfg__err'); msg.textContent = (err && (err.description || err.message)) || 'Erreur, veuillez réessayer.'; setTimeout(function () { msg.parentNode.classList.remove('pc-cfg__err'); msg.textContent = base; }, 5000); })
      .then(function () { btn.classList.remove('is-loading'); });
  };
  C.share = function (btn) {
    var u = new URL(location.origin + location.pathname); u.searchParams.set('model', this.model().handle); u.searchParams.set('variant', this.variant().id); u.hash = 'pc-config';
    var url = u.toString(), lbl = btn.querySelector('span');
    if (navigator.share) { navigator.share({ title: this.model().title, url: url }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { lbl.textContent = 'Lien copié'; setTimeout(function () { lbl.textContent = 'Partager'; }, 2200); });
  };

  C.boot3d = function () {
    var self = this, host = this.q('[data-canvas]'), load = this.q('[data-load]');
    var fail = function () { load.classList.add('is-done'); self.q('[data-fb]').hidden = false; self.root.classList.add('is-fallback'); self.qa('.pc-cfg__tg,.pc-cfg__slider,.pc-cfg__hint').forEach(function (e) { e.hidden = true; }); };
    var start = function () {
      loadThree().then(function (T) {
        try {
          self.viewer = new Viewer(host, T);
          self.viewer.roofVal = +self.q('[data-sl]').value;
          var v = self.variant(); self.viewer.setModel(self.model(), v.color || v.title);
          load.classList.add('is-done');
        } catch (e) { console.error(e); fail(); }
      }).catch(function (e) { console.error(e); fail(); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '300px' });
      io.observe(host);
    } else start();
  };

  function boot() { document.querySelectorAll('[data-pc-cfg]').forEach(function (r) { if (!r.__pc) { r.__pc = 1; new Cfg(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
